@if (tutorial) {
  <div class="tutorial" [ngClass]="{ 'tutorial--internal': tutorial.internalsOnly }" (click)="clicked.emit(tutorial)">
    <div class="tutorial__thumbnail">
      <img [src]="tutorial.thumbnailUrl" alt="thumbnail" />
      @if (tutorial.internalsOnly) {
        <div class="internals-only"><span class="internals-only__text">Internal only</span></div>
      }
      @if (beingDownloaded) {
        <div class="tutorial__thumbnail--downloading" (click)="$event.stopPropagation()">
          <mat-spinner diameter="60"></mat-spinner>
        </div>
      }
    </div>
    <div class="tutorial__name" [ngClass]="{ 'tutorial__name--latest': latest }">
      <span>{{ tutorial.name }}</span>
      <app-edit-menu [tutorial]="tutorial"></app-edit-menu>
    </div>
    <div class="tutorial__date-and-type">
      <span>{{ tutorial.createdDate | date: 'd MMMM yyyy' : 'UTC' }}</span> |
      <span>{{ tutorial.type === 'Video' ? 'VIDEO' : 'PDF' }}</span>
    </div>
    <span class="tutorial__description">{{ tutorial.description }}</span>
  </div>
}
